import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { saveGlobalConfig, updateTimePrecision } from '../../FilterActions';
import { CustomSelect } from '../common';

class TimePrecision extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        { label: 'hh mm', value: 'h[h] m[m]' },
        { label: 'DD hh mm', value: 'd[d] h[h] m[m]' },
        { label: 'DD hh', value: 'd[d] h[h]' },
        { label: 'DD', value: 'd[d]' },
        { label: 'WW DD hh', value: 'w[w] d[d] h[h]' },
        { label: 'MM WW DD', value: 'M[m] w[w] d[d]' },
        { label: 'MM WW', value: 'M[m] w[w]' },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selected) {
    this.props.updateValue(selected);
    this.props.saveConfig();
  }

  render() {
    const { items } = this.state;

    return (
      <CustomSelect
        name={'timePrecision'}
        title={'Cycle time precision'}
        items={items}
        value={this.props.value}
        onSelect={this.handleChange}
      />
    );
  }
}

TimePrecision.propTypes = {};

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveGlobalConfig()),
    updateValue: (val) => dispatch(updateTimePrecision(val)),
  };
};

const mapStateToProps = (state) => {
  return {
    value: state.filters.timePrecision,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(TimePrecision);
export { connected as TimePrecision };
